// extracted by mini-css-extract-plugin
export var popupContainer = "NewsletterPopup-module--popupContainer--2vnJ6";
export var mediaContainer = "NewsletterPopup-module--mediaContainer--2gii3";
export var textContainer = "NewsletterPopup-module--textContainer--30ble";
export var titleWrapper = "NewsletterPopup-module--titleWrapper--2xcMH";
export var closeButton = "NewsletterPopup-module--closeButton--xKx8u";